import { useNavigate } from "react-router-dom";
import { ITotemDevice } from "../../../models/totem-devices";

import MainApiService from "../../../services/mainApi.service";
import { useTranslation } from "react-i18next";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { Table } from "@4uhub/lib4uhub";
import { Chip } from "@mui/material";
const MY_APPS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/TotemDevice/";
const myAppsService = new MainApiService<ITotemDevice>(MY_APPS_ROUTE);

const translationPath = "page.register.totemDevice.";
const TotemDevicesPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<ITotemDevice>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "code",
      headerName: t(translationPath + "code") || "code",
    },
    {
      field: "observation",
      headerName: t(translationPath + "observation") || "description",
      renderCell: (params) => params.value ?? "-",
    },
    {
      field: "enable",
      headerName: t(translationPath + "enable") || "enable",
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={
              params.value
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={params.value ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleRowClick = (params: GridRowParams<ITotemDevice>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<ITotemDevice>
      showDefaultMacroFilters={false}
      service={myAppsService}
      columns={columns}
      title={t(translationPath + "totem_devices")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for a totem"
      }
      addButtonLabel={
        t(translationPath + "add_totem_device") || "Add Totem Devices"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default TotemDevicesPage;
